import { Link } from 'react-router-dom';
import { lotteryCategories } from '@/mocks/categories';

export default function LotteryTypesSection() {
  const displayCategories = lotteryCategories;

  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门彩票玩法
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            多种玩法任您选择，总有一款适合您
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {displayCategories.map((category) => (
            <Link
              key={category.id}
              to={`/lottery?tab=${category.slug}`}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden group hover:border-primary-300/70 transition-all duration-300 cursor-pointer"
            >
              <div className="h-44 overflow-hidden relative">
                <img
                  src={category.thumbnailUrl}
                  alt={category.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-4 right-4">
                  <span
                    className="inline-block px-3 py-1 rounded-full text-xs font-medium text-white"
                    style={{ backgroundColor: category.color }}
                  >
                    {category.drawDays}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center"
                    style={{ backgroundColor: `${category.color}15` }}
                  >
                    <i
                      className={`${category.icon} text-lg`}
                      style={{ color: category.color }}
                    ></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-semibold text-foreground-950 text-sm">
                      {category.name}
                    </h3>
                    <p className="text-foreground-500 text-xs">
                      最低{category.minPrice}元/注
                    </p>
                  </div>
                </div>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {category.shortDesc}
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/lottery"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-full text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            查看全部玩法
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}